import * as React from 'react'
import Box from '@mui/material/Box'
import {useInView} from 'react-intersection-observer'

interface Props {
  children: React.ReactNode
  delay?: number
  duration?: number
}

const Fade: React.FC<Props> = ({children, delay = 100}: Props) => {
  const [ref, inView] = useInView({
    delay: 500,
    triggerOnce: true,
  })
  return (
    <Box ref={ref}>
      <>
        {children}
      </>
    </Box>
  )
}

export default Fade
